import { defineComponent as _defineComponent } from 'vue'
import { formatPercentage } from '@/utils/number';
import { computed } from 'vue';
import { TranslateResult } from 'vue-i18n';


/**
 * Show the trend percentage between a previous and current value.
 *
 * Uses arrows and colors to indicate if it's going up, down or remains static.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ValueTrend',
  props: {
    previousValue: null,
    currentValue: null,
    noTrendMessage: { default: '-' },
    inverse: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { previousValue: number, currentValue: number, noTrendMessage: string | TranslateResult, inverse: boolean };



const differencePercentage = computed(() => {
  const difference = props.previousValue - props.currentValue;
  return (difference * 100) / props.previousValue;
});

const formattedDifferencePercentage = computed(() =>
  formatPercentage(Math.abs(differencePercentage.value), 0),
);

const hasTrendInfo = computed(() => props.previousValue !== 0);

const isTrendGoingUp = computed(() => props.currentValue > props.previousValue);

const isTrendStatic = computed(
  () => props.currentValue === props.previousValue,
);

return { __sfc: true,props, differencePercentage, formattedDifferencePercentage, hasTrendInfo, isTrendGoingUp, isTrendStatic }
}

})